import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { toast } from "react-toastify";
import { URL } from "../api";
import axiosInstance from "../Request";

const FintechWallet = () => {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [updateForm, setUpdateForm] = useState({
    fintechId: "",
    amount: "",
    actionBy: "",
  });
//done
  const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const pad = (num) => (num < 10 ? "0" + num : num);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}`;
  };

  const fetchWallets = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(URL.FINTECH_WALLET);
      setWallets(data);
    } catch (error) {
      console.error("Error fetching wallets:", error);
      toast.error("Failed to fetch wallets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallets();
  }, []);

  const toggleModal = () => {
    if (!showModal) {
      const userName = localStorage.getItem("user_name") || "";
      setUpdateForm({ fintechId: "", amount: "", actionBy: userName });
    }
    setShowModal(!showModal);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateSubmit = async () => {
    const fintechIdNum = Number(updateForm.fintechId);
    const amountNum = Number(updateForm.amount);
    const { actionBy } = updateForm;

    if (!fintechIdNum || !amountNum || !actionBy) {
      toast.error("All fields are required and must be valid numbers.");
      return;
    }

    try {
      await axiosInstance.post(
        `${URL.FINTECH_WALLET.replace("/getAllWallets", "/update")}`,
        null,
        {
          params: {
            fintechId: fintechIdNum,
            amount: amountNum,
            actionBy,
          },
        }
      );
      toast.success("Wallet updated successfully !");
      fetchWallets(); // Refresh table from server start 
      toggleModal();
      setUpdateForm({ fintechId: "", amount: "", actionBy: "" });
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Failed to update wallet"
      );
    }
  };

  if (loading) {
    return <Container className="mt-4">Loading wallets...</Container>;
  }

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7">
        <Container fluid>
          <Row>
            <Col>
              <h1 className="text-white">Fintech Wallets</h1>
            </Col>
            <Col className="text-right">
              <Button color="success" onClick={toggleModal}>
                Update Wallet
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col xl="12">
            <Card className="shadow">
              <CardHeader>
                <h3 className="mb-0">Wallet List</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>ID</th>
                    <th>Fintech ID</th>
                    <th>Amount</th>
                    <th>Total Amount</th>
                    <th>Created Date</th>
                    <th>Last Updated</th>
                  </tr>
                </thead>
                <tbody>
                  {wallets.map((wallet) => (
                    <tr key={wallet.id} style={{ backgroundColor: "#f8f9fa" }}>
                      <td>{wallet.id}</td>
                      <td>{wallet.fintechId}</td>
                      <td>{wallet.amount}</td>
                      <td>{wallet.totalAmount}</td>
                      <td>{formatDateOnly(wallet.createDate)}</td>
                      <td>{formatDateOnly(wallet.updateDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Update Wallet Modal */}
      <Modal isOpen={showModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Update Wallet</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Fintech ID</Label>
              <Input
                type="text"
                name="fintechId"
                value={updateForm.fintechId}
                onChange={handleInputChange}
              />
            </FormGroup>

            <FormGroup>
              <Label>Amount</Label>
              <Input
                type="text"
                name="amount"
                value={updateForm.amount}
                onChange={handleInputChange}
              />
            </FormGroup>

            <FormGroup>
              <Label>Action By</Label>
              <Input
                type="text"
                name="actionBy"
                value={updateForm.actionBy}
                readOnly
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdateSubmit}>
            Update
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FintechWallet;
